import React from 'react'
import { useShowImage } from '../../Hook/App'
import Layout from '../../Layout'
import { Splide, SplideSlide } from '@splidejs/react-splide';
import '@splidejs/react-splide/css';
function ShowImages() {
    const { images, navigate } = useShowImage()
    return (
        <Layout>
            <div style={{ background: "#000", height: "100vh" }}>
                <div className='d-flex justify-content-end px-4 py-3'>
                    <i className='fas fa-times text-white' onClick={() => navigate(-1)}></i>
                </div>
                <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>

                    <Splide options={{ direction: "rtl", arrows: false }}>
                        {images.map((image, i) => {
                            return (
                                <SplideSlide key={i}>
                                    <img style={{ width: "100%", height: "auto", objectFit: "contain" }} src={image} alt="Image 1" />
                                </SplideSlide>
                            )
                        }
                        )}
                    </Splide>
                </div>
            </div>
        </Layout>
    )
}

export default ShowImages